import React, { useEffect, useState } from 'react';
import StatusCardList from './complaint-status-card/StatusCardList';
import ComplaintsGraph from './complaints-graph/ComplaintsGraph';
import Helper from '../../../function/Helper';
import { fetchDashboardInfo, fetchDashboardChartInfo } from '../../../api/hospitality/Dashboard';
import getCustomMenuEffect from '../../../hooks/Menu';

const Dashboard = () => {
  const companyUuid = sessionStorage.getItem('companyUuid') || '';
  const { menu } = getCustomMenuEffect(companyUuid ? companyUuid : '');

  const [dashboardData, setDashboardData] = useState<any>();
  const [loading, setLoading] = useState(true);

  const getDateRange = (date: string) => {
    switch (date) {
      case 'monthly':
        return { type: 'monthly', from: Helper.startOfMonth, to: Helper.endOfMonth };
      case 'weekly':
        return { type: 'weekly', from: Helper.startOfWeek, to: Helper.endOfWeek };
      case 'yearly1':
        return { type: 'yearly', from: Helper.previousStartYear, to: Helper.previousEndYear };
      case 'yearly2':
        return { type: 'yearly', from: Helper.previousTwoStartYear, to: Helper.previousTwoEndYear };
      default:
        return { type: 'yearly', from: Helper.startOfYear, to: Helper.endOfYear };
    }
  };

  const fetchChartData = async (
    type: string,
    date: string,
    setChartData: React.Dispatch<any>,
    setLoading: React.Dispatch<boolean>
  ) => {
    try {
      setLoading(true);
      const { type: dateType, from, to } = getDateRange(date);
      const graph = type;
      const data = await fetchDashboardChartInfo(companyUuid, dateType, from, to, graph);
      const graphData = data?.payload?.data?.trend;
      const formattedData = Object.keys(graphData ? graphData : {}).map((month) => ({
        name: month,
        count: Number(graphData[month])
      }));
      setChartData(formattedData);
    } catch (err: any) {
      console.error('Error fetching chart data', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const { type, from, to } = getDateRange('yearly');
      const data = await fetchDashboardInfo(companyUuid, type, from, to);
      setDashboardData(data?.payload as any);
      sessionStorage.setItem('dateTimeFormat', data?.payload.dateTimeFormat);
    } catch (err: any) {
      console.error('Error fetching data', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="bg-[#1E1E1E] h-[calc(100vh-110px)] py-5 flex flex-col gap-y-5 w-full overflow-y-auto lg:px-5 px-2">
      <StatusCardList dashboardData={dashboardData} />

      <div className="grid lg:grid-cols-2 gap-5">
        {menu.includes('Complaint') && (
          <ComplaintsGraph
            info={dashboardData?.complaints}
            type="Complaint"
            fetchChartData={fetchChartData}
          />
        )}
        {menu.includes('Booking') && (
          <ComplaintsGraph
            info={dashboardData?.bookings}
            type="Booking"
            fetchChartData={fetchChartData}
          />
        )}
        {menu.includes('Feedback') && (
          <ComplaintsGraph
            info={dashboardData?.feedbacks}
            type="Feedback"
            fetchChartData={fetchChartData}
          />
        )}
        {menu.includes('Services') && (
          <ComplaintsGraph
            info={dashboardData?.services}
            type="Services"
            fetchChartData={fetchChartData}
          />
        )}
        {dashboardData?.enquiry && menu.includes('Enquiry') && (
          <ComplaintsGraph
            info={dashboardData?.enquiry}
            type="Enquiry"
            fetchChartData={fetchChartData}
          />
        )}
        {dashboardData?.checkIn && menu.includes('Check-In') && (
          <ComplaintsGraph
            info={dashboardData?.checkIn}
            type="Check-In"
            fetchChartData={fetchChartData}
          />
        )}
      </div>

      {loading && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
